import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import StepBar from '../../../components/StepBar/StepBar';
import Assistito from './WizardSteps/Assistito/Assistito';
import Assistente from './WizardSteps/Assistente/Assistente';
import AnnunciService from '../../../services/AnnunciService';
import Spinner from '../../../components/spinner/Spinner';
import {deleteAnnuncio} from '../../../actions/IndexActions';

const STEPS = [
    {codiceStep: "assistito", nome: "Assistito", cliccabile: false},
    {codiceStep: "assistente", nome: "Assistente", cliccabile: false}
];

function WizardAnnuncio(props) {
    const history = useHistory();
    const annuncioInModifica = props.annuncioReducer?.annuncio || null;
    const isModifica = !!annuncioInModifica?.id;

    const [step, setStep] = useState(0);
    const [showSpinner, setShowSpinner] = useState(false);
    const [dati, setDati] = useState(annuncioInModifica || {});

    function onChange(id, value) {
        setDati(prev => ({...prev, [id]: value}))
    }

    function onProsegui() {
        setStep(1)
    }

    function onIndietro() {
        setStep(0)
    }

    function onSalva() {
        setShowSpinner(true)
        const promise = isModifica
            ? AnnunciService.modificaAnnuncio(annuncioInModifica.id, dati)
            : AnnunciService.inserisciAnnuncio(dati)
        promise
            .then(() => {
                props.deleteAnnuncio()
                history.push('/annunci')
            })
            .catch(err => console.error(err))
            .finally(() => setShowSpinner(false))
    }

    function onAnnulla() {
        props.deleteAnnuncio()
        history.push('/annunci')
    }

    const stepAttivo = step === 0 ? "assistito" : "assistente"

    return (
        <div className={"pt-4"} style={{marginLeft: "30px", marginRight: "30px"}}>
            <Spinner showSpinner={showSpinner}/>
            <div style={{marginBottom: "20px"}}>
                {/* h1 di pagina (WCAG 1.3.1): era un <h5>, promosso a <h1> mantenendo
                    la classe .h5 di Bootstrap, quindi la resa grafica e' identica. */}
                <h1 className={"h5"} style={{fontWeight: "bold"}}>{isModifica ? "Modifica annuncio" : "Nuovo annuncio"}</h1>
            </div>
            <StepBar steps={STEPS} stepAttivo={stepAttivo} col={"col-6"}/>
            {step === 0 && (
                <Assistito
                    dati={dati}
                    onChange={onChange}
                    onProsegui={onProsegui}
                    onAnnulla={onAnnulla}
                />
            )}
            {step === 1 && (
                <Assistente
                    dati={dati}
                    onChange={onChange}
                    onIndietro={onIndietro}
                    onSalva={onSalva}
                    isModifica={isModifica}
                />
            )}
        </div>
    )
}

const mapStateToProps = (state) => ({annuncioReducer: state.annuncioReducer})
const mapDispatchToProps = (dispatch) => ({deleteAnnuncio: () => dispatch(deleteAnnuncio())})
export default connect(mapStateToProps, mapDispatchToProps)(WizardAnnuncio)
